import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';

@Injectable()
export class RentInvoicingOrderCommandHandlerResolver extends CommandHandlerResolver {
  constructor(deleteHandler: DeleteCommandHandler, editHandler: EditCommandHandler) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
  }
}
